import { createContext, useContext } from "react";
import { StoreApi, useStore } from "zustand";
import { CSVResult } from "./helpers/process";

export interface CSVService<T extends CSVResult<unknown> = CSVResult<unknown>> {
  status: 'Idle' | 'Parsing' | 'Validating' | 'Done';
  progress: number;

  maps: Record<string, Record<string, string>>;
  addMapAssociation: (mapId: string, id: string, value: string) => void;
  removeMapAssociation: (mapId: string, id: string) => void;

  result?: T;
  onComplete: (result: T) => void;
}

export const CSVContext = createContext<StoreApi<CSVService> | null>(null);

export function useCSV<U>(selector: (store: CSVService) => U): U {
  const context = useContext(CSVContext);
  if (!context) {
    throw new Error('useCSV must be used within a CSVProvider');
  }
  return useStore(context, selector);
}

export function useResult<T extends CSVResult<unknown>>() {
  return useCSV(state => state.result) as T | undefined;
}

export function useMap(mapId: string) {
  return useCSV(state => state.maps?.[mapId]);
}
